import React from 'react';

type IconProps = {
    color?: string;
    width?: number;
    height?: number;
};

const IconVideoPlay: React.FC<IconProps> = ({ color = 'none', width = 30, height = 30 }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15 0C6.7285 0 0 6.72914 0 15C0 23.2709 6.7285 30 15 30C23.2715 30 30 23.2709 30 15C30 6.72914 23.2715 0 15 0ZM20.9631 15.5255L12.2132 21.1505C12.1106 21.217 11.9922 21.25 11.875 21.25C11.7725 21.25 11.6687 21.2244 11.576 21.1737C11.3745 21.0639 11.25 20.8539 11.25 20.625V9.375C11.25 9.14613 11.3745 8.93613 11.576 8.82627C11.7737 8.71764 12.0215 8.72432 12.2132 8.84947L20.9631 14.4745C21.1414 14.5892 21.25 14.7876 21.25 15C21.25 15.2124 21.1414 15.4107 20.9631 15.5255Z"
                fill="black"
                fill-opacity="0.5"
            />
            <path
                d="M20.9631 15.5255L12.2132 21.1505C12.1106 21.217 11.9922 21.25 11.875 21.25C11.7725 21.25 11.6687 21.2244 11.576 21.1737C11.3745 21.0639 11.25 20.8539 11.25 20.625V9.375C11.25 9.14613 11.3745 8.93613 11.576 8.82627C11.7737 8.71764 12.0215 8.72432 12.2132 8.84947L20.9631 14.4745C21.1414 14.5892 21.25 14.7876 21.25 15C21.25 15.2124 21.1414 15.4107 20.9631 15.5255Z"
                fill="white"
            />
        </svg>
    );
};

export default IconVideoPlay;
